<template>
  <div class="">
    {{ categories }}
  </div>
</template>

<script>
import {convertCategoryInputValueToNames} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Form";

export default {
  name: "FormCategoryAnswer",
  props: {
    answer: {}
  },
  data() {
    return {
      categories: ''
    }
  },
  async mounted() {
    let result = await convertCategoryInputValueToNames(this.answer['label'])
    this.categories = result.map(item => item.name).join(', ')
  }
}
</script>

<style scoped>

</style>